import { Divider, Group, Stack, Text } from '@mantine/core';
import type { PaymentMovement } from '@/models/invoices';

/**
 * Every movement recorded against the invoice, oldest first.
 *
 * It is always on screen while money is being entered, and that is deliberate: nothing stops
 * two accountants recording the same transfer separately, and nothing proves whose entry
 * landed after a lost answer. This list, naming who recorded what and when, is what an
 * accountant reads to know either.
 */
export function PaymentHistory({
  payments,
  currency,
}: {
  payments?: PaymentMovement[];
  currency?: string;
}) {
  if (!payments) return null;

  return (
    <Stack gap={4}>
      <Divider
        label={payments.length ? 'Recorded so far' : 'Nothing recorded yet'}
        labelPosition="left"
      />
      {payments.map((p) => (
        <Group key={p.id} justify="space-between" wrap="nowrap" gap="xs">
          <Text size="xs" c={p.amount < 0 ? 'orange' : undefined} fw={500}>
            {p.amount > 0 ? '+' : ''}
            {p.amount.toFixed(2)} {currency}
          </Text>
          <Text size="xs" c="dimmed" style={{ flex: 1 }}>
            {p.collectedAt}
          </Text>
          <Text size="xs" c="dimmed" truncate>
            {p.recordedByEmail ?? 'unknown'}
          </Text>
        </Group>
      ))}
    </Stack>
  );
}
